import { render, staticRenderFns } from "./BranchDetail.vue?vue&type=template&id=c7dd4992&scoped=true"
import script from "./BranchDetail.vue?vue&type=script&lang=js"
export * from "./BranchDetail.vue?vue&type=script&lang=js"
import style0 from "./BranchDetail.vue?vue&type=style&index=0&id=c7dd4992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dd4992",
  null
  
)

export default component.exports